'use client';

import { LegalPageLayout } from '../components/legal-page-layout';

export const TermsOfServicePage = () => {
	return <LegalPageLayout documentType="terms-of-service" />;
};
